import { render, staticRenderFns } from "./AccessMsg.vue?vue&type=template&id=c36af2fa&lang=pug&"
import script from "./AccessMsg.vue?vue&type=script&lang=js&"
export * from "./AccessMsg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports